import { render, staticRenderFns } from "./HistoryShippingOrder.vue?vue&type=template&id=2fe4b45a&"
import script from "./HistoryShippingOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryShippingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports